import { IsNumberString, IsOptional } from 'class-validator';

export class GlucoseUserIdsQueryDto {
  @IsOptional()
  @IsNumberString()
  lastGlucoseValueMin?: string; // unix timestamp

  @IsOptional()
  @IsNumberString()
  lastGlucoseValueMax?: string; // unix timestamp
}
